import { Tag, Clock } from 'lucide-react';

export default function PriceLots({ priceLots, currentLot }) {
  if (!priceLots || priceLots.length === 0) return null;

  return (
    <div data-testid="price-lots" className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-heading font-bold uppercase text-primary mb-4 flex items-center gap-2">
        <Tag className="w-5 h-5" />
        Lotes de Inscrição
      </h3>
      <div className="space-y-3">
        {priceLots.map((lot) => {
          const isActive = currentLot?.id === lot.id;
          const isExpired = new Date(lot.end_date + 'T23:59:59') < new Date();
          const isFull = lot.max_registrations && (lot.current_registrations || 0) >= lot.max_registrations;

          return (
            <div
              key={lot.id}
              className={`p-4 rounded-lg border-2 transition-all ${
                isActive
                  ? 'border-accent bg-accent/10'
                  : isExpired || isFull
                  ? 'border-border/50 bg-secondary/50 opacity-60'
                  : 'border-border'
              }`}
            >
              <div className="flex justify-between items-start">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-foreground">{lot.name}</span>
                    {isActive && (
                      <span className="text-xs bg-accent text-accent-foreground px-2 py-0.5 rounded-full font-bold">
                        ATIVO
                      </span>
                    )}
                    {(isExpired || isFull) && (
                      <span className="text-xs bg-foreground/20 text-foreground/70 px-2 py-0.5 rounded-full font-bold">
                        {isFull ? 'ESGOTADO' : 'ENCERRADO'}
                      </span>
                    )}
                  </div>
                  <div className="flex items-center gap-1 text-sm text-foreground/70 mt-1">
                    <Clock className="w-4 h-4" />
                    <span>até {new Date(lot.end_date).toLocaleDateString('pt-BR')}</span>
                  </div>
                  {lot.max_registrations && (
                    <p className="text-xs text-foreground/50 mt-1">
                      {lot.current_registrations || 0} / {lot.max_registrations} vagas
                    </p>
                  )}
                </div>
                <span className={`text-xl font-bold ${isActive ? 'text-accent' : 'text-foreground/70'}`}>
                  R$ {lot.price.toFixed(2)}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
